module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-wrapper"
  }, [_c('span', {
    ref: "progress-bar",
    staticClass: "progress-bar",
    style: ({
      Width: _vm.progressPercent + '%'
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e01c358"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleProgress.vue
// module id = 81
// module chunks = 0